import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';
import { ConfigSchema } from './division';

/**
 * League Schema (formerly called Season)
 * Represents a league (competition period) within an organization, optionally linked to a tournament
 */

export const LeagueSchema = z.object({
  _id: objectId,
  name: z.string().optional(),
  contestType: z.string().default('season'),
  priority: z.number().optional(),
  admins: z.array(objectId).default([]),
  config: ConfigSchema.optional(),
  sports: z.array(z.string()).default([]),
  startDate: z.coerce.date().default(() => new Date()),
  active: z.boolean().default(true),
  // Refs
  tournament: objectId,
  // Top-level paymentProduct REMOVED (ADR 0034) — fee lives at config.paymentProduct.
  organization: objectId,
  ...timestampFields,
});

export type League = z.infer<typeof LeagueSchema>;

// Metadata for League fields (for Mongoose refs and UI)
export const leagueMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  name: { label: 'League Name', editable: true },
  contestType: { label: 'Contest Type', editable: true },
  priority: { label: 'Priority', editable: true },
  sports: { label: 'Sports', editable: true },
  startDate: { label: 'Start Date', editable: true },
  active: { label: 'Active', editable: true },
  admins: { ref: 'Admin', label: 'Admins' },
  tournament: { ref: 'Tournament', label: 'Tournament' },
  organization: { ref: 'Organization', hidden: true },
  created: { hidden: true },
  updated: { hidden: true },
};
